import { combineReducers } from 'redux';
import { dataServiceReducer as dataService } from 'resift';
import store from 'store/store';

// Store
import app from './app';
import attribute from './attribute';
import authentication from './authentication';
import client from './client';
import config from './configuration';
import directories from './directories';
import homepageWidgets from './homepageWidgets';
import search from './search';
import sources from './sources';
import siftBot from './siftBot';
import themes from './themes';
import companyApi from './companyAPI';
import onboarding from './onboarding';

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    app,
    attribute,
    authentication,
    client,
    config,
    directories,
    homepageWidgets,
    search,
    sources,
    siftBot,
    themes,
    companyApi,
    onboarding,
    dataService,
    ...asyncReducers,
  });
};

export const injectReducer = ({ key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
